export default function Header() {
  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-background-50">
      <div className="w-full border-b border-foreground-200/60">
        <div className="flex items-center justify-center px-8 md:px-16 py-5 md:py-6">
          <a href="/" className="block cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/880ffd8e-de16-4e33-8809-efab8f30f9a5_compressed_main_logo_pc2x.webp"
              alt="GIAZO"
              className="h-7 md:h-9 w-auto object-contain"
            />
          </a>
        </div>
      </div>
    </header>
  );
}